// Attempts to get any focusable elements within the parent element passed in.
// Note that this will not work for anything inside of a shadow dom.
export default function getFocusableElements(element) {
  try {
    const elements = element.querySelectorAll(`
      a[href]:not([disabled]):not([tabindex="-1"]),
      button:not([disabled]):not([tabindex="-1"]),
      textarea:not([disabled]):not([tabindex="-1"]),
      input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]),
      select:not([disabled]):not([tabindex="-1"]),
      .lds-focusable,
      [tabindex]:not([tabindex="-1"]),
      iframe:not([tabindex="-1"]),
      [contentEditable=true]:not([tabindex="-1"])`);

    return Array.from(elements).filter((el) => el.offsetHeight > 0);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`LDS ERROR [Unexpected Failure]: Failed to getFocusableElements: ${err.message}`, `\n>>> in element ${element}`);
    return [];
  }
}
